import React from 'react';
import block from 'bem-cn';
import { useActiveRequests } from '../../model/activeRequests/useActiveRequests';
import ActiveRequestItem from './ActiveRequestItem/ActiveRequestItem';
import ActiveRequestModal from './ActiveRequestModal/ActiveRequestModal';
import FiltersPanel from './FiltersPanel/FiltersPanel';
import Paginator from 'components/Paginator';

import InstructionButton from './InstructionButton/InstructionButton';
import './ActiveRequests.scss';
import { shallowEqual, useSelector } from 'react-redux';

const b = block('active-requests-desktop');

const ActiveRequests = () => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);

  const { input, output } = useActiveRequests();

  const items = output.items.map(item => (
    <ActiveRequestItem
      key={item.id}
      item={item}
      onApprove={() => input.handleRequestApprove({ id: item.id })}
      onReject={() => input.handleItemOpen(item)}
    />
  ));

  const handleFiltersSubmit = filters => {
    input.handleGetRequests(filters);
  };

  return (
    <div className={b()}>
      <div className={b('title')}>
        {locale.requests}
        <div className={b('title-instruction')}>
          <InstructionButton />
        </div>
      </div>

      <div className={b('filters-wrapper')}>
        <FiltersPanel onSubmitFilters={handleFiltersSubmit} />
      </div>

      <article className={b('content')}>
        <ActiveRequestModal
          item={input.activeItem}
          note={input.values.note}
          onClose={input.handleItemClose}
          onNoteChange={input.handleNoteChange}
          onSend={input.handleRequestReject}
        />
        <div className={b('items')}>
          {items && items.length > 0 ? items : <div className={b('empty')}>{output.locale.emptyActiveRequests}</div>}
        </div>
      </article>
      <div className={b('paginator')}>
        <Paginator currentPage={input.values.page} pageCount={output.pages} onPageClick={input.handlePageChange} />
      </div>
    </div>
  );
};

export default ActiveRequests;
